




























































import Vue from 'vue'
import { Navigation } from '@/config/interfaces'
import StickyPage from '@/components/StickyPage.vue'
import BottomNavigation from '@/components/BottomNavigation.vue'
import SideNavigation from '@/components/SideNavigation.vue'
import Header from '@/components/Header.vue'
import OldBrowserDialog from '@/views/OldBrowserDialog.vue'
import Utils from '@/helpers/Utils'
import { apiRoutes } from '@/helpers/ApiRoutes'

export default Vue.extend({
  name: 'App',

  components: {
    Header,
    StickyPage,
    BottomNavigation,
    SideNavigation,
    OldBrowserDialog
  },

  data: () => ({
    loadedApp: false,
    loadedPages: false
  }),

  mounted () {
    if (this.userAuthenticated) {
      this.loadMainData()
    }
  },

  watch: {
    showPinEnter: function () {
      this.loadMainData()
    }
  },

  methods: {
    loadMainData () {
      this.$axios.get(apiRoutes.indexHome)
        .then(res => {
          if (this.$router.currentRoute.name === 'ResetPin') {
            this.$router.push({ name: 'ResetPin' }).catch(() => { /* Do nothing */ })
            return
          }

          if (this.showPinEnter) {
            this.$router.push({ name: 'PinEnter' }).catch(() => { /* Do nothing */ })
            return
          }
          this.$store.commit('setMainData', res.data.data)
          this.loadedApp = true
          this.loadedPages = true
          // Get first element in navigation object and set its title as the first left view title
          if (this.bottomNavigation !== null) {
            const firstNavigationKey = Object.keys(this.bottomNavigation)[0]
            this.setLeftViewTitle(this.bottomNavigation[firstNavigationKey].title)
            // Set first navigation item key as active navigation key
            this.setCurrentNavigationKey(firstNavigationKey)
          }
        })
        .catch(() => {
          this.$store.state.errorOccurred = true
          this.$router.push({ name: 'Error' }).catch(() => { /* Do nothing */ })
        })
    },
    setLoadedPages (loaded: boolean) {
      this.loadedPages = loaded
    },
    setLeftViewTitle (title: string) {
      this.$store.dispatch('changeLeftViewTitle', title)
    },
    setCurrentNavigationKey (key: string) {
      this.$store.dispatch('changeCurrentNavigationKey', key)
    },
    isOldBrowser: function (): boolean {
      return Utils.isOldBrowser()
    },
    pauseAudio: function () {
      if (this.$store.getters.getAudio !== null) {
        this.$store.getters.getAudio.pause()
      }
    }
  },

  computed: {
    showBottomNav (): boolean {
      return this.$vuetify.breakpoint.mdAndDown
    },
    bottomNavigation (): Navigation | null {
      return this.$store.getters.getNavigation
    },
    userAuthenticated (): boolean {
      return this.$store.getters.isAuthenticated
    },
    showMainContent (): boolean {
      // hide only when left view is active on mobile
      return this.isDesktop || !this.$store.getters.getLeftViewState
    },
    showPinEnter (): boolean {
      return this.$store.getters.requirePin
    },
    errorOccurred (): boolean {
      return this.$store.state.errorOccurred
    }
  }
})
